import { styled as muiStyled } from '@mui/material'

export const SelectTableWrapper = muiStyled('div')(
  ({ theme }) => `
  height: 100%;
  
.position-relative{
    height: 100%;
    display: flex;
    flex-direction: column;
}
    .table-responsive{
        flex-grow: 1;
    }
`,
)
